import React from 'react'

function Admin() {
console.log("admin");
  return (
    <div>Admin</div>
  )
}

export default Admin